import { useEffect, useState } from "react";
import Ticket from "../../../../common/components/ticket/ticket";
import { ticketLayouts } from "../../../../common/constants/ticketLayouts";
import "./createCampaignTicket.scss";
import { ReactComponent as Arrow } from "../../../../assets/arrowIcon.svg";
import { Color } from "../../../../common/style/colors";
import TicketDetailArea from "../ticketDetailArea/ticketDetailArea";
import { TicketDetailModel } from "../../models/ticketDetailModel";

export default function CreateCampaignTicket(props: {
  totalScore?: number;
  initialValue?: TicketDetailModel;
  onChange?: (e: TicketDetailModel) => void;
}) {
  const [campaignTicketData, setCampaignTicket] = useState<TicketDetailModel>(
    props.initialValue ?? {
      layoutNumber: 0,
    }
  );

  useEffect(() => {
    props.onChange?.(campaignTicketData);
  }, [campaignTicketData]);

  return (
    <div className="create-campaign-ticket">
      <div className="tickets-container">
        <div
          className={[
            "ticket-arrow-left ",
            campaignTicketData?.layoutNumber === 0
              ? "ticket-arrow-disable"
              : "",
          ].join(" ")}
          onClick={() =>
            (campaignTicketData?.layoutNumber ?? 0) > 0 &&
            setCampaignTicket({
              ...campaignTicketData,
              layoutNumber: (campaignTicketData.layoutNumber ?? 0) - 1,
            } as TicketDetailModel)
          }
        >
          <Arrow width={15} height={15} stroke={Color().tertiaryColor} />
        </div>
        <Ticket
          ticketLayout={ticketLayouts[campaignTicketData?.layoutNumber ?? 0]}
        />
        <div
          className={[
            "ticket-arrow-right ",
            campaignTicketData?.layoutNumber === 3
              ? "ticket-arrow-disable"
              : "",
          ].join(" ")}
          onClick={() =>
            (campaignTicketData?.layoutNumber ?? 0) < 3 &&
            setCampaignTicket({
              ...campaignTicketData,
              layoutNumber: (campaignTicketData.layoutNumber ?? 0) + 1,
            } as TicketDetailModel)
          }
        >
          <Arrow width={15} height={15} stroke={Color().tertiaryColor} />
        </div>
      </div>
      <TicketDetailArea
        initialValue={campaignTicketData}
        onChange={(e) => setCampaignTicket(e)}
        totalScore={props.totalScore}
      />
    </div>
  );
}
